import { render, staticRenderFns } from "./NpaProject.vue?vue&type=template&id=eaa2fc18"
import script from "./NpaProject.vue?vue&type=script&lang=js"
export * from "./NpaProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports